import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { isSet } from "../../../utils/commonUtils";
import { activeProfileDetails } from "../../../store/SessionSlice";
import SessionTimeout from "../../../hoc/SessionTimeout";
import PERMISSIONS from "../../../utils/AclPermissions";
import { useDispatch } from "react-redux";
// import { clearCbState } from "../../../store/GlobalFilterSlice";
import NotificationMessage from "../AppLayout/NotificationMessage";
import { fetchNotificationStatus, fetchRxntPendingNotificationCount } from "../../../store/NotificationSlice";
import { isUserbillingModuleElabled } from "../../../utils/aclUtils";
import { clearCbState } from "../../../store/GlobalFilterSlice";
import NewMenus from "./NewMenus";
import { setIsNewUI } from "../../../store/CommonSlice";
import Acl from "../../../hoc/Acl";
import Icons from "../../UI/Icons";
import Buttons from "../../UI/Buttons";
import { useLocation } from "react-router-dom";
import VideoPlayer from "../../../containers/VideoConfigContainer/VideoPlayer";

const NewAppLayout = (props) => {
  const { children } = props;
  const [activeMenu, setActiveMenu] = useState('');
  const [mainMenusList,setMainMenusList]  = useState([]);
  const [configMenusList,setConfigMenusList] = useState([]);
  const dispatch = useDispatch();
  const [showNotification,setShowNotification]=useState(false);   
  const [tutorial,setTutorial] = useState(false) 
  // let currentPath = window.location.pathname;
  const location = useLocation();  
  const currentPath = location.pathname;
  const panelRef = useRef(null);
  const toggleRef = useRef(null)
  const profileDetails = useSelector(activeProfileDetails);
  const reloadId = useSelector(state=>state.common.reloadKeyProps);
  useEffect(()=>{
 
    let MenusData = [];
    let Configures = [];
    if (isSet(profileDetails?.role,'') === "global_admin" || isSet(profileDetails?.is_multiple_organization,'') === true) {
      MenusData = [
        {
          title: "Organization",
          link: "/organisation",
          acl: ['organization-list'],
          iconType: "organization",
        },
        {
          title: "Organization Companies",
          link: "/company",
          acl: ['company-list'],
          iconType: "Company",
        },
        // {
        //   title: "Labs",
        //   link: "/labs",
        //   acl: ['result-list'],
        //   iconType: "Labs",
        // },
        // {
        //   title: "Results",
        //   // link: "/result/physical-drug-screens",
        //   acl: ['result-list'],
        //   iconType: "Results",
        //   attr:{
        //     'data-bs-toggle':"collapse",
        //     'data-bs-target':'#results-submenu1'
        //   },
        //   subMenuId:'results-submenu1',
        //   subMenu:[
        //     {
        //       title: "Vaccines",
        //       link: "/result/vaccine",
        //       acl: ['result-list'],
        //       iconType: "PatientChart",
        //     },
        //     {
        //       title: "Physicals & Drug Screens",
        //       link: "/result/physical-drug-screens",
        //       acl: ['result-list'],
        //       iconType: "PatientChart",
        //     },
        // ],
        // },
        {
          title: "Organization Chart",
          link: "/employee",
          acl: ['employee-list'],
          iconType: "PatientChart",
        },
      ];
      Configures = [
        { Title: "Users", link: "/users", acl: 'user-list' },
        { Title: "Role & Permissions", link: "/roles", acl: 'role-list' },
        { Title: "Clinics", link: "/clinics", acl: 'clinic-list' },
        { Title: "Providers", link: "/providers", acl: 'provider-list' },
        { Title: "Referral Providers", link: "/referral-providers", acl: 'referral-provider-list' },
        { Title: "Laboratory", link: "/laboratory", acl: 'lab-list' },
        { Title: "Clinic Department", link: '/clincs-department', acl: 'clinic-department-list' },
        { Title: "Insurance", link: '/insurance', acl: 'insurance-list' },
        { Title: "Work Comp Insurance", link: '/workcomp-insurance', acl: [PERMISSIONS.WORK_COMP_INSURANCE.LIST] },
        { Title: "Company Divisions", link: "/division", acl: ['company-division-list'] },
        { Title: "Lookup", link: "/lookup", acl: ['lookup-list'] },
        { Title: "Basic Physical", link: "/basic-physical", acl: ['basic-physical-list'] },
        { Title: "Activities", link: "/activities", acl: ['activities-list'] },
        { Title: "Compliance Monitor", link: "/compliance-monitor", acl: [PERMISSIONS.COMPLIANCE_MONITOR.LIST] },
        { Title: "Contract Pricing", link: "/contract/pricing", acl: ['contract-list'] },
        { Title: "CPT Code", link: "/cpt-code", acl: [PERMISSIONS.CPT.LIST] },
        { Title: "ICD-10 Code", link: "/icd10-code", acl:  [PERMISSIONS.ICD10.LIST]  },
        { Title: "Intake Paperwork", link: "/intake-paperwork", acl: ['consent-list'] },
        { Title: "Vaccine Administration", link: "/vaccine-administration", acl: ['vaccine-administration-list'] },
        { Title: "SFTP Configuration", link: "/configure", acl: [PERMISSIONS.SFTP_CONFIGURATION.LIST] },
        { Title: "CSV Imports", link: "/csv-import", acl: [PERMISSIONS.CSV_IMPORT.LIST] },
        { Title: "Failed EZ-Reader", link: "/failed-ez-reader", acl:[PERMISSIONS.FAILED_EZ_READER.LIST] },
        { Title: "Notification Log", link: "/notification-log", acl: [PERMISSIONS.NOTIFICATION_LOG.LIST] },
        { Title: "HL7 Log", link: "/hl7/log", acl: [PERMISSIONS.HL7_LOG.LIST] },
        { Title: "Audit Log", link: "/audit-log", acl: [PERMISSIONS.AUDIT_LOG.LIST] },
        { Title: "Merge History", link: "/merge-history", acl: [PERMISSIONS.MERGE_PATIENT.LIST] },
        { Title: "Patient Transfer History", link: "/clone-history", acl: [PERMISSIONS.EMPLOYEE.EDIT] },
        { Title: "AI Diagnosis Logs", link: "/ai-diagnosis-logs", acl: [PERMISSIONS.AI_DIAGNOSIS_LOGS.LIST] },
        { Title: "DOT Submission Logs", link: "/dot-submission-logs", acl: [PERMISSIONS.DOT_SUBMISSION_LOGS.LIST] },
        { Title: "EMR Setup", link: "/emr" ,acl:[PERMISSIONS.EMR_CONFIGURATION.LIST]  },
        { Title: "Random Generator", link: "/random-generator" ,acl:[PERMISSIONS.RANDOM_GENERATOR.LIST]  },
        { Title: "State Forms Configuration", link: "/forms-configuration" ,acl:[PERMISSIONS.STATE_FORMS.LIST]},
        { Title: "Lab Panel Configuration", link: "/lab-pannel-configuration", acl:[PERMISSIONS.LAB_PANEL.LIST]  },
        { Title: "Lab Panel Manual Import", link: "/lab-pannel-import", acl:[PERMISSIONS.LAB_PANEL.LIST]   },
        { Title: "Tutorial Video Configure", link: "/video-configure", acl: [PERMISSIONS.TUTORIAL_VIDEO.LIST] },
        { Title: "Notification Template", link: "/notification-template", acl: [PERMISSIONS.NOTIFICATION_TEMPLATE.LIST] },
        { Title: "Data Permission Template", link: "/data-permission-template", acl: [PERMISSIONS.DATA_PERMISSION_TEMPLATE.LIST] },
        // { Title: "Clearinghouse", link: "/clearing-house", acl: [PERMISSIONS.CLEARING_HOUSE.LIST] },   
      ];
    }else {
      MenusData = [
        {
          title: "Dashboard",
          link: "/dashboard",
          acl: [PERMISSIONS.DASHBOARD.LIST] ,
          // iconType: "NewDasboardIcon",
          iconType: "DashboardIcon",
        },
        // {
        //   title: "Companies",
        //   link: "/company",
        //   acl: ['company-list'],
        //   iconType: "NewCompaniesIcon",
        // },
        {
          title: "Appointments",
          link: "/appointments",
          acl:['appointment-list'],
          // iconType: "NewAppointmentsIcon",
          iconType: "Schedule",
        },
        {
          title: "White Board",
          link: "/white-board",
          acl: ['white-board-list'],
          // iconType: "NewWhiteboard",
          iconType: "WhiteBoard",
        },
        {
          title: "Visits",
          link: "/visits",
          acl: ['visits-list'],
          // iconType: "NewVisitIcon",
          iconType: "PatientVisit",
        },
        {
          title: "Results",
          // link: "/result/physical-drug-screens",
          acl: ['result-list'],
          // iconType: "NewResultIcon",
          iconType: "Results",
          attr:{
            "id":"userDropdown",
            "role":"button",
            "data-bs-toggle":"dropdown",
             "aria-haspopup":"true"
          },
          subMenuId:'results-submenu',
          subMenu:[
            {
              title: "Labs",
              link: "/labs",
              acl: ['result-list'],
              // iconType: "NewLabsIcon",
              iconType: "Labs",
            },
            {
              title: "Vaccines",
              link: "/result/vaccine",
              acl: ['result-list'],
              iconType: "NewVaccinesIcon",
            },
            {
              title: "Physicals & Drug Screens",
              link: "/result/physical-drug-screens",
              acl: ['result-list'],
              iconType: "NewPhysicalDrugIcon",
            },
             {
              title: "Work Status",
              link: "/result/workstatus",
              acl: ['result-list'],
              iconType: "WorkStatus", 
            },
            {
              title: "RXNT Prescriptions",
              link: "/result/rxnt-prescriptions",
              acl: ['result-list'],
              iconType: "Results",
            }
        ],
          
        },
        {
          title: "Patients",
          link: "/employee",
          acl: ['employee-list'],
          iconType: "NewPatientsIcon",
        },
        // {
        //   title: "Biller Report",
        //   // link: "/result/physical-drug-screens",
        //   acl: ['result-list'],
        //   iconType: "Results",
        //   attr:{
        //     'data-bs-toggle':"collapse",
        //     'data-bs-target':'#reports-submenu'
        //   },
        //   subMenuId:'reports-submenu',
        //   subMenu:[
        //     {
        //       title: "Lab Report",
        //       link: "/reports",
        //       acl: ['result-list'],
        //     },
        //     {
        //       title: "Diagnosis Report",
        //       link: "/reports",
        //       acl: ['result-list'],
        //     },
        // ],
          
        // },
        {
          title: "Billing",
          link: `${process.env.REACT_APP_COLLECTOR_URL}/login/healthcare?user_id=${profileDetails.id}`,
          // link:`https://snapcollector.com`,
          acl:isUserbillingModuleElabled(profileDetails) ? 'any':'',
          iconType: "NewBillingIcon",
        },
        {
          title: "Reports",
          link: "/reports",

          acl:[PERMISSIONS.REPORTS.LIST],

          // iconType: "NewReportsIcon",
          iconType: "Reports",

        },
         {
          title: "Incident",
          link: "/incident",
          acl: [PERMISSIONS.INCIDENT.LIST],
          // iconType: "NewIncidentIcon",
          iconType: "Incident",
        },
      ];
      Configures = [
        { Title: "Companies", link: "/company", acl: ['company-list'] },
        { Title: "Users", link: "/users", acl: 'user-list' },
        { Title: "Role & Permissions", link: "/roles", acl: 'role-list' },
        { Title: "Clinics", link: "/clinics", acl: 'clinic-list' },
        { Title: "Providers", link: "/providers", acl: 'provider-list' },
        { Title: "Referral Providers", link: "/referral-providers", acl: 'referral-provider-list' },
        { Title: "Laboratory", link: "/laboratory", acl: 'lab-list' },
        { Title: "Clinic Department", link: '/clincs-department', acl: 'clinic-department-list' },
        { Title: "Insurance", link: '/insurance', acl: 'insurance-list' },
        { Title: "Company Divisions", link: "/division", acl: ['company-division-list'] },
        { Title: "Lookup", link: "/lookup", acl: ['lookup-list'] },
        { Title: "Basic Physical", link: "/basic-physical", acl: ['basic-physical-list'] },
        { Title: "Activities", link: "/activities", acl: ['activities-list'] },
        { Title: "Compliance Monitor", link: "/compliance-monitor", acl: [PERMISSIONS.COMPLIANCE_MONITOR.LIST] },
        { Title: "Contract Pricing", link: "/contract/pricing", acl: ['contract-list'] },
        // { Title: "Contract Approvals", link: "/contract/approval", acl: ['activities-list'] },
        { Title: "Intake Paperwork", link: "/intake-paperwork", acl: ['consent-list'] },
        { Title: "Vaccine Administration", link: "/vaccine-administration", acl: ['vaccine-administration-list'] },
        { Title: "CSV Imports", link: "/csv-import", acl: [PERMISSIONS.CSV_IMPORT.LIST] },
        { Title: "Import Historical Visit", link: "/historical-visit-import", acl: [PERMISSIONS.HISTORICAL_VISIT.LIST, PERMISSIONS.CSV_IMPORT.LIST] },
        { Title: "Failed EZ-Reader", link: "/failed-ez-reader", acl: [PERMISSIONS.FAILED_EZ_READER.LIST] }, 
        { Title: "Notification Log", link: "/notification-log", acl: [PERMISSIONS.NOTIFICATION_LOG.LIST] },
        { Title: "HL7 Log", link: "/hl7/log", acl:  [PERMISSIONS.HL7_LOG.LIST] },
        { Title: "Audit Log", link: "/audit-log", acl: [PERMISSIONS.AUDIT_LOG.LIST] },

        { Title: "Merge History", link: "/merge-history", acl: [PERMISSIONS.MERGE_PATIENT.LIST] },
        { Title: "Patient Transfer History", link: "/clone-history", acl: [PERMISSIONS.EMPLOYEE.EDIT] },
        { Title: "EMR Setup", link: "/emr", acl:[PERMISSIONS.EMR_CONFIGURATION.LIST]  },
        { Title: "Random Generator", link: "/random-generator" ,acl:[PERMISSIONS.RANDOM_GENERATOR.LIST]},  
        { Title: "Scheduled Patients", link: "/random-scheduled-patients", acl:[PERMISSIONS.VISIT_SCHEDULE.LIST]},
        { Title: "State Forms Configuration", link: "/forms-configuration" ,acl:[PERMISSIONS.STATE_FORMS.LIST]},
        { Title: "Lab Panel Configuration", link: "/lab-pannel-configuration", acl:[PERMISSIONS.LAB_PANEL.LIST] },
        { Title: "Lab Panel Manual Import", link: "/lab-pannel-import", acl:[PERMISSIONS.LAB_PANEL.LIST] },
        { Title: "DOT Submission Logs", link: "/dot-submission-logs" , acl: [PERMISSIONS.DOT_SUBMISSION_LOGS.LIST]},
      ];
    } 
    // else if(isSet(profileDetails) && isSet(profileDetails?.role[0],'') === "company_employee"  && isSet(profileDetails?.is_multiple_organization,false) === false) {
    //   MenusData = [
        
    //     {
    //       title: "Appointments",
    //       link: "/appointments",
    //       acl: ['appointment-list', 'employee-list'],
    //       iconType: "Schedule",
    //     },
    //     {
    //       title: "Labs",
    //       link: "/labs",
    //       acl: ['result-list'],
    //       iconType: "Labs",
    //     },
    //     {
    //       title: "Results",
    //       acl: ['result-list'],
    //       iconType: "Results",
    //       attr:{
    //         'data-bs-toggle':"collapse",
    //         'data-bs-target':'#results-submenu'
    //       },
    //       subMenuId:'results-submenu',
    //       subMenu:[
    //         {
    //           title: "Vaccines",
    //           link: "/result/vaccine",
    //           acl: ['result-list'],
    //           iconType: "PatientChart",
    //         },
    //         {
    //           title: "Physicals & Drug Screens",
    //           link: "/result/physical-drug-screens",
    //           acl: ['result-list'],
    //           iconType: "PatientChart",
    //         },
    //       ],
          
    //     },
    //   ];
    //   Configures = [];
      
    // }
    setMainMenusList(MenusData)
    setConfigMenusList(Configures);
  },[profileDetails])
  
  // Sync highlighted nav with URL on every route change (incl. browser back/forward)
  useEffect(() => {
    if (!mainMenusList.length && !configMenusList.length) return;
    const path = currentPath;
    let matchingMenu = mainMenusList.find(menu =>
      isSet(menu?.subMenu, false) == false
        ? path.startsWith(menu.link)
        : menu.subMenu.find((sub) => path.startsWith(sub.link))
    );
    if (matchingMenu) {
      setActiveMenu(matchingMenu.title);
    } else {
      matchingMenu = configMenusList.find((menu) => path.startsWith(menu.link));
      if (matchingMenu) {
        setActiveMenu(matchingMenu.Title);
      }
    }
  }, [currentPath, mainMenusList, configMenusList]);
  const sideBarChangeHandler = useCallback(() => {
    setConfigureActive((prev)=>!prev);
    console.log('configureActive',configureActive);
    
    // if (document.body.classList.contains('show-sidebar')) {
    //   document.body.classList.remove('show-sidebar');
    //   // menuToggleElement.removeClass('active');
    // } else {
    //   document.body.classList.add('show-sidebar');
    // }
  }, []);

//   useEffect(()=>{
//     if (document.body.classList.contains('show-sidebar')) {
//       document.body.classList.remove('show-sidebar');
//     } 
//     dispatch(clearCbState());
//   },[activeMenu])

  const removeSideBar=()=>{
    // document.body.classList.remove('show-sidebar');
  };

  

//   useEffect(() => {
//     const handleMouseUp = (e) => {
//       const container = document.querySelector(".sidebar");
//       const linkElement = document.querySelector(".js-menu-toggle");

//       // Check if the clicked element is the link
//       if (!container.contains(e.target) && isSet(linkElement) && !linkElement.contains(e.target)) {
//         if (document.body.classList.contains('show-sidebar')) {
//           document.body.classList.remove('show-sidebar');
//           // Optionally, you can uncomment the line below if you have a menuToggleElement.
//           // menuToggleElement.classList.remove('active');
//         }
//       }
//     };

//     document.addEventListener('mouseup', handleMouseUp);
    
//     return () => {
//       document.removeEventListener('mouseup', handleMouseUp);
//     };
    
    
//   }, []);
  const [configureActive,setConfigureActive] = useState(false);
 useEffect(()=>{
  document.title = 'Snap HealthCare | '+isSet(activeMenu,'Home');
  dispatch(fetchNotificationStatus());
  dispatch(fetchRxntPendingNotificationCount());
 },[activeMenu, dispatch]);

 const notificationToogleHandler=()=>{
  setShowNotification(!showNotification)
 }

  useEffect(() => {
    if (showNotification) {
      dispatch(fetchRxntPendingNotificationCount());
    }
  }, [showNotification, dispatch]);
 const tutorialToogleHandler=()=>{
  setTutorial(!tutorial)
 }
  const flattenedAclArray = useMemo(()=>{
    return configMenusList.flatMap(item => Array.isArray(item.acl) ? item.acl.flat() : [item.acl]);
  },[configMenusList])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        configureActive &&
        panelRef.current &&
        !panelRef.current.contains(event.target) &&
        toggleRef.current &&
        !toggleRef.current.contains(event.target)
      ) {
        setConfigureActive(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [configureActive]);
  return (
    <>
    <SessionTimeout timeout={process.env.REACT_APP_SESSION_TIMEOUT} />
    <div className={""}>
      <div id="wrapper">
       
        <div id="content-wrapper" className="d-flex flex-column">
          {/* <!-- Main Content --> */}
            <div id="content">
              <NewMenus
                MenusData={mainMenusList}
                Configures={configMenusList}
                setActiveMenu={setActiveMenu}
                currentPath={currentPath}
                activeMenu={activeMenu}
                sideBarChangeHandler={sideBarChangeHandler}
                removeSideBar={removeSideBar}
                notificationToogleHandler={notificationToogleHandler}
                tutorialToogleHandler={tutorialToogleHandler}
              />
              <div className="container-fluid">
                <div className="sh_mainPortview mb-0" id="sh_mainportal_view">
                  <div className="sh_innerPortview" key={reloadId}>
                    {
                      showNotification ?
                        <NotificationMessage
                          modleToogleHandler={notificationToogleHandler}
                        />
                        :
                        <></>
                    }
                    {tutorial &&
                    <>
                      <VideoPlayer tutorialToogleHandler={tutorialToogleHandler} />
                    </>
                    }

                    {children}
                  </div>
                </div>
              </div>
              <div className="container-footer">
                <Acl acl={flattenedAclArray}>
                  <div ref={toggleRef} className={`nav-item menu_Settings border-top ${configureActive == true ? 'sh_activeMenu' : ''}`}>
                    {/* <a
                      className="nav-link js-menu-toggle no_arrow"
                      href={"#"}
                      
                      data-bs-toggle="collapse"
                    > */}
                    <div class="pl-3 pt-2 nav-link js-menu-toggle no_arrow">
                           <a class="btn btn-primary sh_btnprimary" type="button"  onClick={(e) => {   e.preventDefault();sideBarChangeHandler(); }}>
                              <span class="">
                                 <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="7.99994" cy="8.00006" r="6.0025" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                                    <path d="M4.71638 13.0167L7.14028 10.5928C8.3075 11.0272 9.62135 10.7213 10.4765 9.81585C11.3317 8.91045 11.5623 7.58129 11.0621 6.44073C11.0544 6.42516 11.0397 6.41419 11.0226 6.41113C11.0055 6.40808 10.9879 6.4133 10.9753 6.42522L8.94148 8.41171L7.51868 6.98891L9.50208 5.00552C9.51445 4.99283 9.51988 4.97492 9.51664 4.95749C9.5134 4.94007 9.5019 4.9253 9.48579 4.9179C8.31481 4.41514 6.95601 4.67139 6.04858 5.56611C5.17882 6.4166 4.8992 7.70339 5.33757 8.83814L2.94531 11.2304" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                 </svg>
                              </span>
                              Configure
                           </a>
                          </div>
                      {/* <div className="sh_sidebarnav_item">
                        <span className="sh_menuIcon d-block">
                          <Icons type="Settings" />
                        </span>
                        <label className="text-gray-600 sh_sidebarnav_title" style={{color:"blue",cursor:"pointer"}}>Configure</label>
                      </div> */}
                    {/* </a> */}
                  </div>
                </Acl>
                <div ref={panelRef} className={`side_Inner sliding-panel ${configureActive ? 'open' : ''}`}>
                  <div className="nav-link">
                    {configMenusList.map((item, index) => {
                      const isActive = (activeMenu === item.Title) ? 'active' : '';
                      return (
                        <li style={{ 'listStyle': 'none' }} key={index} onClick={() => {setActiveMenu(item.Title);setConfigureActive(false) }}>
                          <Buttons
                            acl={item.acl}
                            accessType={'Hide'}
                            href={item.link}
                            className={`side_InnerText ${isActive}`}
                            key={index}
                            label={item.Title} />
                        </li>

                      )
                    })}
                  </div>

                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};


export default (NewAppLayout);
